import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import ContactUs from "./components/Contact";
import GameDetail from "./components/GameDetail";
import Disclaimer from "./components/Disclaimer";
import PrivacyPolicy from "./components/PrivacyPolicy";
// import { Helmet } from "react-helmet";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        {/* <Helmet> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/game/:gameId" element={<GameDetail />} />

          </Routes>
        {/* </Helmet> */}

        <Footer />
      </div>
    </Router>
  );
}

export default App;
